function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 0a1 1 0 00-1 1v5.46l-1 .67V1a1 1 0 00-2 0v6.13l-1-.67V1a1 1 0 00-2 0v6a1 1 0 00.45.83L11 9.54V19a1 1 0 002 0V9.54l2.55-1.71A1 1 0 0016 7V1a1 1 0 00-1-1zM5 0a5 5 0 00-5 5v6a1 1 0 001 1h3v7a1 1 0 102 0V1a1 1 0 00-1-1zM4 10H2V5a3 3 0 012-2.83V10z"
});

function SvgUtensils(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20
  }, props), _ref);
}

export default SvgUtensils;